/**
 * Lumina Theme
 *
 * Extends the base tealsTheme with Lumina-specific overrides
 * for the AI agent management portal.
 *
 * Because TealsTheme is defined with `as const` (literal string types),
 * we widen the type so that Lumina can override colour values.
 */
import { tealsTheme } from '@teals/tokens';

// Deeply converts every leaf value of T to `string`.
type DeepString<T> = T extends string
  ? string
  : T extends number
    ? number
    : T extends object
      ? { [K in keyof T]: DeepString<T[K]> }
      : T;

export type LuminaTheme = DeepString<typeof tealsTheme>;

export const luminaLightTheme: LuminaTheme = {
  ...tealsTheme,
  colors: {
    ...tealsTheme.colors,
    primary: {
      ...tealsTheme.colors.primary,
      400: '#2d9a8f',
      500: '#2d9a8f',
      600: '#1a7a70',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
      elevated: '#ffffff',
    },
    text: {
      ...tealsTheme.colors.text,
      primary: '#0f172a',
      secondary: '#475569',
      disabled: '#94a3b8',
      hint: '#64748b',
      inverse: '#ffffff',
    },
    border: {
      light: '#e2e8f0',
      main: '#cbd5e1',
      dark: '#94a3b8',
    },
  },
};

export const luminaDarkTheme: LuminaTheme = {
  ...tealsTheme,
  colors: {
    ...tealsTheme.colors,
    primary: {
      ...tealsTheme.colors.primary,
      400: '#4eb8ad',
      500: '#4eb8ad',
      600: '#2d9a8f',
    },
    background: {
      default: '#0f172a',
      paper: '#1e293b',
      elevated: '#334155',
    },
    text: {
      ...tealsTheme.colors.text,
      primary: '#f1f5f9',
      secondary: '#cbd5e1',
      disabled: '#64748b',
      hint: '#94a3b8',
      inverse: '#0f172a',
    },
    border: {
      light: '#334155',
      main: '#475569',
      dark: '#64748b',
    },
  },
};
